module.exports = __webpack_public_path__ + "img/user.1d1b15de.svg";